// Auth-related constants
export const AUTH_CONSTANTS = {
  // Token keys
  TOKEN_KEYS: {
    ACCESS: 'access_token',
    REFRESH: 'refresh_token',
    API: 'api_token',
    USER: 'user',
    AUTH_STATE: 'auth_state',
  },
  
  // Timeouts and delays
  LOGOUT_RESET_DELAY: 2000,
  CLIENT_RESET_DELAY: 1000,
  
  // API configuration
  API_TIMEOUT: 10000,
  
  // Auth-related key patterns for cleanup
  CLEANUP_PATTERNS: [
    'token',
    'auth',
    'user',
    'login',
    'session'
  ],
  
  // Routes
  ROUTES: {
    SIGNIN: '/signin',
    HOME: '/',
    NOT_FOUND: '*',
  },
  
  // Events
  EVENTS: {
    LOGOUT_REQUIRED: 'auth:logout-required',
  }
} as const;

// Type definitions for better TypeScript support
export type TokenKey = typeof AUTH_CONSTANTS.TOKEN_KEYS[keyof typeof AUTH_CONSTANTS.TOKEN_KEYS];
export type CleanupPattern = typeof AUTH_CONSTANTS.CLEANUP_PATTERNS[number];
export type AuthRoute = typeof AUTH_CONSTANTS.ROUTES[keyof typeof AUTH_CONSTANTS.ROUTES];
export type AuthEvent = typeof AUTH_CONSTANTS.EVENTS[keyof typeof AUTH_CONSTANTS.EVENTS];
